import React, { Component } from "react";
import PropTypes from "prop-types";

import moment from "moment";
import Controls from "./Controls";
import Tags from "./Tags";

class Post extends Component {
	renderText(text) {
		return (
			<div className="text">
				<div dangerouslySetInnerHTML={{ __html: text }} />
			</div>
		);
	}

	renderImage(text, imageUrl) {
		return (
			<div className="image">
				<img alt="post" src={imageUrl} />
				<div className="text-container" dangerouslySetInnerHTML={{ __html: text }} />
			</div>
		);
	}

	renderVideo(text, videoUrl, imageUrl = "") {
		const imagePreviewStyle = {
			backgroundImage: `url(${imageUrl.replace(/\(/g, "%28").replace(/\)/g, "%29")})`,
			backgroundSize: "cover",
			backgroundPosition: "center",
			position: "relative",
		};
		return (
			<div className="image video">
				<div style={imagePreviewStyle} className="image-container">
					<div className="video-overlay">
						<a href={videoUrl} target="_blank">
							<i className="far fa-play-circle"></i>
						</a>
					</div>
				</div>
				<div className="text-container" dangerouslySetInnerHTML={{ __html: text }} />
			</div>
		);
	}

	render() {
		const { item, crud } = this.props;
		const { text, imageUrl, videoUrl, tags, publishAt, id } = item;
		let toDisplay;
		if (text && videoUrl && imageUrl) {
			toDisplay = this.renderVideo(text, videoUrl, imageUrl);
		} else if (text && imageUrl) {
			toDisplay = this.renderImage(text, imageUrl);
		} else if (text) {
			toDisplay = this.renderText(text);
		}
		const timeAgo = moment(publishAt).fromNow();

		return (
			<div key={id} className="post">
				<Controls id={id} crud={crud} />
				{toDisplay}
				<Tags tags={tags} />
				<p className="time-ago">{timeAgo}</p>
			</div>
		);
	}
}

Post.propTypes = {
	item: PropTypes.object,
	crud: PropTypes.object,
};

export default Post;
